import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const fileWriteNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('fileWrite'),
    controlValues: z.object({
        encoding: z.enum([ 'utf-8', 'ascii', 'latin1', 'utf16le', 'base64', 'hex' ]).default('utf-8'),
        append: z.boolean().default(false),
        createIfNotExists: z.boolean().default(true),
    }),
});

export interface FileWriteNodeCfgSchema extends z.infer<typeof fileWriteNodeCfgSchema> {}

export const fileWriteNodeCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: () => ({
            filePath: 'string',
            fileContents: 'string',
        }),
        outputs: () => ({}),
    },
} satisfies NodeSocketCfg<FileWriteNodeCfgSchema>;
